import React from "react";
import { Container, Row, Col, Card, ListGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "react-bootstrap-icons";
import { motion } from "framer-motion";
import { Seo } from "../components/Seo";
import { generateStaticPageSEO } from "../lib/seo/metaGenerators";

const guidelines = [
  "Wash/sanitize your hands thoroughly before handling food.",
  "Ensure all food is properly sealed and packaged before delivery.",
  "Keep hot foods hot and cold foods cold during transport.",
  "Sanitize delivery bags and containers regularly.",
  "Avoid direct contact with food; use gloves or utensils when necessary.",
  "Contactless delivery is encouraged to minimize risk.",
  "If you feel unwell, do not handle or deliver food.",
  "Follow all local health and safety regulations.",
  "Double-check order accuracy before leaving the restaurant.",
  "Communicate clearly with customers about delivery status.",
];

const SafetyGuidelines = () => {
  const navigate = useNavigate();
  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh" }}>
      <Seo {...generateStaticPageSEO({
        title: "Safety Guidelines",
        description: "Teco's food safety guidelines for delivery riders and restaurant partners, from restaurant to doorstep.",
        path: "/safety-guidelines",
      })} />
      <Container className="py-5">
        <Row className="justify-content-center mb-4">
          <Col md={8} lg={7}>
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-4"
            >
              <img
                src="/imgs/security-ilustration.svg"
                alt="Safety Illustration"
                className="img-fluid mb-3"
                style={{ maxHeight: 180, filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.08))" }}
              />
              <h2 className="fw-bold text-primary mb-2 d-flex justify-content-center align-items-center gap-2" style={{ fontSize: "2rem" }}>
                <ShieldCheck size={28} className="text-primary" />
                Food Delivery Safety Guidelines
              </h2>
              <p className="text-muted mb-0" style={{ lineHeight: 1.7 }}>
                We are committed to ensuring the safety of your food from restaurant to doorstep.<br />
                Please review our safety guidelines below:
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
            >
              <Card className="shadow border-0 mb-4" style={{ borderRadius: 18 }}>
                <Card.Body className="p-0">
                  <ListGroup variant="flush">
                    {guidelines.map((item, idx) => (
                      <ListGroup.Item
                        key={idx}
                        className="py-3 px-4 d-flex align-items-start"
                        style={{ background: idx % 2 === 0 ? "#f8fafc" : "#fff" }}
                      >
                        <span className="fw-bold text-primary me-3" style={{ fontSize: 20 }}>{idx + 1}.</span>
                        <span className="text-dark" style={{ fontSize: "1.08rem" }}>{item}</span>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Card.Body>
              </Card>
              <div className="d-flex justify-content-center">
                <Button
                  variant="outline-primary"
                  className="rounded-pill px-4 d-flex align-items-center gap-2 shadow-sm"
                  style={{ fontWeight: 500, fontSize: "1.05rem" }}
                  onClick={() => navigate(-1)}
                >
                  <ArrowLeft size={18} /> Back
                </Button>
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SafetyGuidelines; 